export function parseUrl() {
  const arrUrl = window.location.hash.split('/');
  const categoryGroup = arrUrl[1];
  const categoryName = arrUrl[2];
  const templateId = arrUrl[3];
  const noControls = arrUrl[4] == 'no-controls';
  return [categoryGroup, categoryName, templateId, noControls];
}
